import { render } from "./OrderDetailDialog.vue?vue&type=template&id=2aa35eb5&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"

import "./OrderDetailDialog.vue?vue&type=style&index=0&id=2aa35eb5&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa35eb5"]])

export default __exports__